













































import { getMasterFactByPhrase, getFactByID } from "@/models/Fact.ts";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class MasterFactAssociation extends Vue {
  @Prop({ type: Number }) id!: number;
  @Prop({ type: Number }) year!: number;
  @Prop({ type: String }) iso3!: string;
  @Prop({ type: String }) type!: string;
  @Prop({ type: String }) displacement_type!: string;
  @Prop({ type: String }) role!: string;

  private initItem!: any;
  private loading: boolean = false;
  private items: object[] = [];
  private phrase: string = "";

  async created() {
    if (this.id) {
      try {
        let { data } = await getFactByID(this.id);
        this.initItem = data;
        this.items = [this.initItem];
      } catch (error) {
        console.error(error);
      }
    }
  }

  get disabled(): boolean {
    let { year, iso3, type, displacement_type } = this;
    return !(!!year && !!iso3 && !!type && !!displacement_type);
  }

  @Watch("phrase")
  async onPhraseChanged(value: any, oldValue: any) {
    this.loading = true;
    if (value && value.length > 1 && value !== oldValue) {
      const { iso3, displacement_type, type, year } = this;
      let response = await getMasterFactByPhrase(
        value,
        iso3,
        displacement_type,
        type,
        year
      );

      this.items = [...response.data];
      if (!!this.initItem) {
        this.items.push(this.initItem);
      }
    }
    this.loading = false;
  }

  updateValue(value: any) {
    let payload = { id: this.id, role: this.role, ...value };

    // Manage role
    if (payload.id === null || typeof payload.id === "undefined") {
      payload.id = null;
      payload.role = null;
    } else if (payload.role === null || payload.role === "") {
      payload.role = "Partial figure (Added)";
    }

    this.$emit("change", payload);
  }
}
